var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"toolbar",staticClass:"toolbar",class:{
    'toolbar-sticked': _vm.isSticked,
    'toolbar-shadow': _vm.addShadow
  }},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"toolbar-contents"},[_c('div',{staticClass:"toolbar-left"},[_vm._t("left")],2),(_vm.$slots.right)?_c('div',{staticClass:"toolbar-right"},[_vm._t("right")],2):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }